<template>
  <v-card>
    <v-toolbar :color="type.color" dark dense flat>
      <v-toolbar-title>
        <v-icon>{{ type.icon }}</v-icon>
        {{ type.title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" md="4" v-if="device.imei">
            <h3 class="body-2 grey--text">IMEI</h3>
            <span class="title black--text">{{ device.imei }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="device.store">
            <h3 class="body-2 grey--text">חנות</h3>
            <span class="title black--text">{{ store.title }}</span>
          </v-col>
          <v-col cols="12" md="4" v-if="device.boxType">
            <h3 class="body-2 grey--text">מגירה</h3>
            <span class="title black--text">{{ boxType.title }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">תאריך רכישה</h3>
            <span
              class="title black--text"
            >{{ device.purchaseDate == null? '-':format(device.purchaseDate,"DD/MM/YYYY") }}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">שייך לחשבונית</h3>
            <span class="title black--text">{{ device.purchaseDate == null? '-': device.invoiceId}}</span>
          </v-col>
          <v-col cols="12" md="4">
            <h3 class="body-2 grey--text">סטאטוס</h3>
            <span class="title black--text">{{ networkStatus.title == null? '-': networkStatus.title}}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { format } from "date-fns";
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {
    store() {
      return this.$store.state.entities.stores[this.device.store];
    },
    boxType() {
      return this.$store.state.entities.boxTypes[this.device.boxType];
    },
    networkStatus() {
      return this.$store.state.entities.networkStatusTypes[
        this.device.networkStatusType
      ];
    }
  },
  props: ["device", "type"],
  watch: {},
  mounted() {},
  methods: {
    format,
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    }
  },
  components: {},
  mixins: []
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>